module.exports = __webpack_public_path__ + "fefc5d34041d22fc57e6480c4614fc21.eot";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Regular.eot
// module id = 10
// module chunks = 0